import React from 'react'

const TaskColorChip = ({ color = '#6d747a' }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="14"
      viewBox="0 0 6 14"
      fill="none"
      style={{ flexShrink: 0 }}
    >
      <path
        d="M0 11V3C0 1.34315 1.34315 0 3 0C4.65685 0 6 1.34315 6 3V11C6 12.6569 4.65685 14 3 14C1.34315 14 1.61064e-08 12.6569 0 11Z"
        fill={color}
      />
    </svg>
  )
}

export default TaskColorChip
